<div class="content-with-stepper-and-title">
    <main>
        <vcl-alert type="error" [dismissible]="false" *ngIf="areFilesSizeIncorrect()" class="alert-margin">
         {{copyService.copies.attach_documents.exceeds_file_size}}{{fileMaxSize}}{{copyService.copies.attach_documents.exceeds_file_size_MB}}
        </vcl-alert>

        <vcl-alert type="error" [dismissible]="false" *ngIf="areFilesTypeIncorrect()" class="alert-margin">
            {{copyService.copies.attach_documents.not_file_type}}
           </vcl-alert>

        <div class="row">
            <div class="field col-12 col-pr-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-8">
                <h1 [innerHtml]="copyService.copies.attach_documents.description"></h1>
                <h1 class="mt-3">{{copyService.copies.attach_documents.consultation}}<a class='link_cursor' id='link_cursor' (click)="next(201)"><u>{{copyService.copies.attach_documents.document_requirements}}</u></a></h1>
            </div>
        </div>

        <div class="margin-docs" *ngFor="let document of documentList; index as i">
            <div>
                <h1 id="product_sub_type" class="width-xbold small-letter mb-2" innerHtml="{{document.priority === 'R' ? document.archive_name + ' (Requerido)' : document.archive_name + ' (Opcional)'}}"></h1>
                <div class="row mt-3">
                    <div class="field col-12 col-pr-6 col-sm-4 col-md-6 col-lg-6 col-xl-6">
                        <vcl-form-field label="{{ copyService.copies.attach_documents.file }}">
                            <a class="disp-flex orange">
                            <input
                            vclInput placeholder="{{ copyService.copies.attach_documents.file_placeholder }}"
                            id="i"
                            name="input-file-{{i}}"
                            type="file"
                            readonly="readonly"
                            (change)="onDocumentChange($event)"
                            onkeypress="return false;"
                            accept=".pdf,.jpg">
                            <h1 id="text{{i}}" [ngClass]="document.file? 'black width-light display-text w-100 small-mid-letter line-h' : 'gray width-light display-text w-100 small-mid-letter line-h'" [innerHtml]="document.file? document.file.name : copyService.copies.attach_documents.file_placeholder"></h1>
                            <voxel-icon *ngIf="document.fileExists" (click)="removeDocument(i)">excluir_outline</voxel-icon></a>
                        </vcl-form-field>
                    </div>
                    <div class="field col-2 col-pr-4 col-sm-3 col-md-3 col-lg-3 col-xl-3 disp-flex send-button">
                        <vcl-button id="attachDocs" buttonType="contextual" [label]="copyService.copies.attach_documents.file_button" 
                            (click)="selectUploadDocument(i)" class="w-100"
                            [disabled]="(areFilesSizeIncorrect() || areFilesTypeIncorrect()) && (document.isFileSizeCorrect && document.isFileTypeCorrect)">
                        </vcl-button>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="field col-12 col-pr-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <h1 [innerHtml]="copyService.copies.attach_documents.send_documents"></h1>
                <h1 class="xsmall-letter mt-2" [innerHtml]="copyService.copies.attach_documents.document_validation"></h1>
            </div>
        </div>
    </main>
    <div class="row disp-flex mt-40">
        <div class="field col-12 col-pr-8 col-sm-8 col-md-8 col-lg-8 col-xl-8">
            <app-controls class="mt-4 button-back" [hasPrevious]="true" [previousLabel]="copyService.copies.attach_documents.back_button" [nextLabel]="copyService.copies.attach_documents.next_button" (next)="sendDocuments()" (previous)="next(200)" [nextDisabled]="disableButton"></app-controls>
        </div>
    </div>
</div>
  